import { useSelector } from 'react-redux';
import {
  useGetAllDomainsQuery,
  useGetAllFoldersQuery,
  useGetBridgedEventsQuery,
} from '../../services/api';
import { selectIsEventsPlatform } from '../../redux/slices/platform/platformSlice';
import { EVENT_PAGE_SIZE } from '../../constants/events/eventStatus';

const hasAccessToken = () => {
  try {
    const token = localStorage.getItem('accessToken');
    return Boolean(token) && token !== 'undefined';
  } catch {
    return false;
  }
};

/**
 * Loads the lists most visits open next (events, the agents dashboard, domains) as soon as
 * the user is signed in, so those pages render from cache instead of waiting on the API.
 *
 * The arguments must match the pages' own queries exactly, or RTK Query treats them as a
 * different cache entry. These subscriptions live for the whole session, so the data stays
 * cached and refetches through the usual tag invalidation after a create, edit or delete.
 * Playbooks are already loaded globally by usePlaybookHandler.
 */
function useWarmTopLevelQueries() {
  // `auth.isAuth` starts as true until useAuthHandler has read the token, so check the token
  // itself. Without it these queries 401 on the login page, the 401 handler logs out and
  // reloads /login, and the page loops.
  const isAuth = useSelector(state => state.auth.data.isAuth) && hasAccessToken();
  const isEventsPlatform = useSelector(selectIsEventsPlatform);

  // Events page (useEventsHandler), first page.
  useGetBridgedEventsQuery(
    { page: 1, limit: EVENT_PAGE_SIZE },
    { skip: !isAuth || !isEventsPlatform }
  );
  // Agents dashboard folders and agents (useAgentDashboardHandlers, outside an event).
  useGetAllFoldersQuery(undefined, { skip: !isAuth || isEventsPlatform });
  // Domains: agent create/edit, Websites and the agents list all read this.
  useGetAllDomainsQuery(undefined, { skip: !isAuth });
}

export default useWarmTopLevelQueries;
